import { uploadController } from 'lib/ajax_upload';

/**
 * Proxy for lib/ajax_upload:controller
 * @param {JQuery} $container
 */
export function controller($container) {
    return uploadController($container);
}
